<template>
  <b-card
    title="Date *"
    class="shadow-sm h-100"
  >

    <vc-date-picker
      ref="forDateCal"
      :value="formDate.forDate.value"
      @input="$emit('didChangeForDate', $event)"
      is24hr
      locale="fr"
      color="orange"
      :popover="{ visibility: 'click' }"
      :minute-increment="5"
      :first-day-of-week="2"
      :modelConfig="modelConfig"
      :max-date="new Date().getTime()"
    >
      <template v-slot="{ inputValue, inputEvents }">
        <input
          class="border px-2 py-1 rounded for-date-datepicker mt-2"
          :class="{'is-invalid': formDate.forDate.state === false}"
          :value="inputValue"
          v-on="inputEvents"
          placeholder="Date"
        />
      </template>
    </vc-date-picker>

    <div class="mt-2">
      <b-form-group>
        <b-form-radio-group
          id="isMorning-radio-group"
          :checked="formDate.isMorning.value"
          @input="$emit('didChangeIsMorning', $event)"
          name="isMorning"
        >
          <b-form-radio :value="true">Matin</b-form-radio>
          <b-form-radio :value="false">Soir</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </div>

    <div class="main-red-color" v-if="formDate.forDate.invalidFeedback">
      {{formDate.forDate.invalidFeedback}}
    </div>
  </b-card>

</template>

<script>
export default {
  name: "DailyStatusCardDate",

  props: {
    formDate: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      modelConfig: {
        type: 'number',
        timeAdjust: '10:00:00'
      }
    }
  }

}
</script>

<style scoped>
.for-date-datepicker {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--main-text-color);
  height: calc(1.5em + 0.75rem + 2px);
  border: 1px solid var(--neutral-300) !important;
  border-radius: 0.25rem;
  width: 100%;
}
.for-date-datepicker.is-invalid {
  border: solid var(--main-red) 1px !important;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23767676' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat, var(--main-white) url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F4464F' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F4464F' stroke='none'/%3e%3c/svg%3e") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat
}
</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/cards/DailyStatusCardDate.vue